import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { MsalProvider, withMsal } from '@azure/msal-react'
import { PublicClientApplication } from '@azure/msal-browser'
import mssignin from '../../assets/ms-signin.svg'

class LoginButton extends Component {
  static propTypes = {
    msalContext: PropTypes.object,
    createOAuthSession: PropTypes.func.isRequired
  }

  handleClick = async () => {
    try {
      const result = await this.props.msalContext.instance.loginPopup(
        {
          scopes: ['openid', 'email'],
          redirectUri: window.location.origin
        }
      )

      this.props.createOAuthSession(result.idToken)
    } catch (error) {
      // Azure login failed or aborted
    }
  }

  render() {
    return (
      <div className="pure-u-1 azure-login">
        <button
          className="pure-button azure-login-button"
          onClick={this.handleClick}
        >
          <img src={mssignin} alt="Sign in with Microsoft" />
        </button>
      </div>
    )
  }
}

const MsalLoginButton = withMsal(LoginButton)

class AzureOAuthLogin extends Component {
  static propTypes = {
    createOAuthSession: PropTypes.func.isRequired,
    clientId: PropTypes.string
  }

  constructor(props) {
    super(props)

    this.pca = new PublicClientApplication({
      auth: {
        clientId: this.props.clientId,
        authority: 'https://login.microsoftonline.com/ideonapi.onmicrosoft.com'
      }
    })
  }

  render() {
    return (
      <MsalProvider instance={this.pca}>
        <MsalLoginButton createOAuthSession={this.props.createOAuthSession} />
      </MsalProvider>
    )
  }
}

export default AzureOAuthLogin
